// extracted by mini-css-extract-plugin
module.exports = {"darkDrumMachine":"DrumMachine_darkDrumMachine__ijsWW","lightDrumMachine":"DrumMachine_lightDrumMachine__1DMzZ","drumMachine":"DrumMachine_drumMachine__3pvzj"};